import { render, staticRenderFns } from "./StoryPage.vue?vue&type=template&id=0f043d63&scoped=true&"
import script from "./StoryPage.vue?vue&type=script&lang=ts&"
export * from "./StoryPage.vue?vue&type=script&lang=ts&"
import style0 from "./StoryPage.vue?vue&type=style&index=0&id=0f043d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f043d63",
  null
  
)

export default component.exports